<cm-overlay header="{{ 'ASSISTANCE_REQUEST_SUCCESS' | translate }}" [width]="800" [height]="600">
  <h2 class="confirmation" style="text-align: center">
    {{ "ASSISTANCE_REQUEST_SENT_SUCCESS" | translate }}
  </h2>
  <cm-choice-selector
    [choices]="[{ id: 0, label: 'OK' }]"
    (choiceSelected)="onSelection($event)"
  ></cm-choice-selector>
</cm-overlay>
